export interface Vec2 {
  x: number
  y: number
}

export const v2 = (x = 0, y = 0): Vec2 => ({ x, y })

export function len(v: Vec2): number {
  return Math.hypot(v.x, v.y)
}

export function norm(v: Vec2): Vec2 {
  const l = len(v)
  return l > 1e-6 ? { x: v.x / l, y: v.y / l } : { x: 0, y: 0 }
}

export function dist(ax: number, ay: number, bx: number, by: number): number {
  return Math.hypot(bx - ax, by - ay)
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t
}

/** Shortest-path angular interpolation. */
export function lerpAngle(a: number, b: number, t: number): number {
  let d = (b - a) % (Math.PI * 2)
  if (d > Math.PI) d -= Math.PI * 2
  if (d < -Math.PI) d += Math.PI * 2
  return a + d * t
}
